module.exports = __webpack_public_path__ + "static/media/CTBC-UX-7-hilight-transfer.9e88875e.png";